import { render, staticRenderFns } from "./NewProposalModal.vue?vue&type=template&id=3f68bf24"
import script from "./newProposalModal.ts?vue&type=script&lang=ts&external"
export * from "./newProposalModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f68bf24')) {
      api.createRecord('3f68bf24', component.options)
    } else {
      api.reload('3f68bf24', component.options)
    }
    module.hot.accept("./NewProposalModal.vue?vue&type=template&id=3f68bf24", function () {
      api.rerender('3f68bf24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/modal/manager/newProposal/NewProposalModal.vue"
export default component.exports